export const redirectToElectron = (pathname = '', params?: URLSearchParams): void => {
  let href = `gologin://${pathname}`;
  if (params) {
    href = `${href}?${params.toString()}`;
  }

  window.open(href, '_self');
};
